<template>
  <Clientes></Clientes>
</template>

<script>
import { defineComponent } from 'vue'

import Clientes from '../components/Clientes.vue'

export default defineComponent({
  name: 'ClientesView',

  components: {
    Clientes
  }
})
</script>
